<script>
import store from '@state/store'
import PostForm from '@router/components/post-form.vue'
import { authComputed } from '@state/helpers'

export default {
  name: 'PostFormWrapper',
  components: {
    PostForm,
  },
  props: {
    companyId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      refreshPostForm: false,
      loadingMore: false,
      lastPostPoints: 0,
    }
  },
  computed: {
    ...authComputed,
    shouldRefreshPostForm() {
      return this.refreshPostForm
    },
  },
  methods: {
    postStatusUpdate(params) {
      store
        .dispatch('companies/postNewStatusUpdate', {
          text: params.text,
          hours: params.hours,
          kyndCode: params.kyndCode,
          amount: params.amount,
          type: params.postType,
          kyndnessType: params.kyndnessType,
          userId: this.currentUser.id,
          updatableId: this.companyId,
          updatableType: 'company',
          postAnonymous: params.postAnonymous,
          challenge: params.challenge,
          giver: params.giver,
          organization: params.organization,
          causes: params.causes,
          friends: params.friends,
          tags: params.tags,
          images: params.images,
          videoUrl: params.videoUrl,
        })
        .then((newPost) => {
          // reset and hide form
          this.refreshPostForm = newPost.id
        })
        .catch(() => {})
    },
    closePointsModal() {
      this.showEarnedPoints = false
    },
  },
}
</script>

<template>
  <div>
    <PostForm
      :key="shouldRefreshPostForm"
      :company-id="companyId"
      @post-status-update="postStatusUpdate"
    >
    </PostForm>
  </div>
</template>
